import { createFileRoute } from '@tanstack/react-router'
import { FraudAnalysisUpgradePage } from 'features/fraudAnalysis'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/upgrade')({
  component: FraudAnalysisUpgradePage,
})
